import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headerLabel: {
    id: 'studio.79IWia',
    defaultMessage: 'Header',
  },
  headerHelp: {
    id: 'studio.hW9ZYr',
    defaultMessage: 'The header for header based authentication',
  },
  secretLabel: {
    id: 'studio.CtZMCP',
    defaultMessage: 'Secret',
  },
  secretHelp: {
    id: 'studio.GmeoMq',
    defaultMessage: 'The secret for header based authentication',
  },
});
